import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

import type { ResultType } from 'modules/command_bar/components/CommandBar/plugins/types'
import { useCommandBar } from 'modules/command_bar/lib/commandBarContext'

import ResultLink from './ResultLink'
import './index.styles.css'
type Props = ResultType & {
  selected: boolean
  onMouseEnter: (id: string) => void
  onSubmit: (id: string) => void
}

const Result = (props: Props) => {
  const { id, text, IconComponent, type, selected, onMouseEnter, onSubmit, DetailsComponent } =
    props
  const navigationPath = type === 'navigation' ? props.navigationPath : '#'
  const { setOpen } = useCommandBar()
  const isExternal = type === 'navigation' && !!props.external

  const action = type === 'action' ? props.action : null

  const generatedAction = useUnsafeCallback(() => {
    if (!isExternal) {
      setOpen?.(false)
    }

    onSubmit(id)
    action?.()
  }, [setOpen, isExternal, onSubmit, id, action])

  return (
    <ResultLink
      isExternal={isExternal}
      navigationPath={navigationPath}
      generatedAction={generatedAction}
    >
      <Box
        flexDirection="row"
        padding="s12"
        gap="s12"
        borderRadius={{ all: 'abs006' }}
        alignItems="center"
        onMouseEnter={() => onMouseEnter(id)}
        className={selected ? 'Result_selectedResult' : undefined}
      >
        <Box width="s24" height="s24" justifyContent="center" alignItems="center">
          <IconComponent />
        </Box>
        <Box width="full" justifyContent="center">
          <Text.Normal>{text}</Text.Normal>
        </Box>
        {DetailsComponent && (
          <Box justifyContent="center">
            <DetailsComponent />
          </Box>
        )}
      </Box>
    </ResultLink>
  )
}

export default React.memo(Result)
